import { render, staticRenderFns } from "./ReturnVisitorXsell.vue?vue&type=template&id=5ecf442e&scoped=true&lang=pug&"
import script from "./ReturnVisitorXsell.vue?vue&type=script&lang=js&"
export * from "./ReturnVisitorXsell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecf442e",
  null
  
)

export default component.exports